import { JobsOfferListItem } from "./jobs-offer-list-item.model";

export const IJobsEtabOffers = Object.freeze({
  total: "total",
  jobsOffers: "jobsOffers",
});

export class JobsEtabOffersModel {
  constructor(data = {}) {
    this[IJobsEtabOffers.total] = data[IJobsEtabOffers.total];
    this[IJobsEtabOffers.jobsOffers] = data[IJobsEtabOffers.jobsOffers];
  }

  getTotal() {
    return parseInt(this[IJobsEtabOffers.total], 10);
  }

  getEtabOffersList() {
    return (this[IJobsEtabOffers.jobsOffers] || []).map((offer) => new JobsOfferListItem(offer));
  }
}
